export default {
    title: 'Doc Dog',
    back: 'Back',
    continue: 'Continue',
    backToMenu: 'Back to main menu',
    retry: 'Restart Level',
    game: {
        gameMenu: {
            title: 'Pause',
        },
        planner: {
            start: 'Start',
        },
        tutorial: {
            introduction: {
                text1: 'You are a dog. It used to be your lovely granny who took care of you. She gave you tasty food, ' +
                    'combed your fur and took you for nice walks to the park. But granny got old and sick and now it ' +
                    'is up to you to take care of her. She has a lot of prescriptions from her doctor which help with' +
                    'her illnesses and keep her alive, but she forgets to take her medicine unless you arrange it for ' +
                    'her in her pill box. To do so click on a pill and drag into a slot pill box. ' +
                    'Granny will take this pill at the time for which you placed it in the box.' +
                    'Diary: After each day you can read grannies diary to find out how she was feeling during the day.' +
                    'Symptoms from Illnesses start at a certain time of the day. If Granny suffers from an illnesses on ' +
                    'one day, she will suffer from it for the rest of the week (always at the same time). The diary entries will ' +
                    'also give you information on how the pills you put into the box interacts with her illnesses, her status, the time of day and each other.' +
                    'Tip: You can start the first day without giving granny any medicine to understand which ' +
                    'illnesses granny is suffering from.' +
                    'Prescription: You can read the prescription for each pill by clicking on it. It gives ' +
                    'you some information about each pill, but be aware that this' +
                    'information might be incomplete. Learn more about additional effects of a pill by checking ' +
                    'grannies reaction to it based on her diary entries.' +
                    'Drooling: Try to memorize the prescriptions and diary entries you read as your drool will make ' +
                    'them less readable everytime you touch it.' +
                    'Duration of pill effects: Pills have a certain duration of effect which is stated in the description. ' +
                    'E.g. if a pill which lasts 3 steps is taken in the morning its effect will last until noon. ' +
                    'If granny throws up all pills will loose effect immediately.',
                text: 'You are a dog. It used to be your lovely granny who took care of you. She gave you tasty food, ' +
                    'combed your fur and took you for nice walks to the park. But granny got old and sick and now it ' +
                    'is up to you to take care of her. She has a lot of prescriptions from her doctor which help with' +
                    'her illnesses and keep her alive, but she forgets to take her medicine unless you arrange it for ' +
                    'her in her pill box. To do so click on a pill and drag into a slot pill box. ' +
                    'Granny will take this pill at the time for which you placed it in the box.',
                next: 'Let\'s go',
            },
            status: {
                text: 'Keep an eye open for how your granny is feeling! Different medication has different effects, so you might need to adjust accordingly.',
            },
            pills: {
                text: 'You have a limited amount of pills for each prescription. Pills have a certain duration of effect which is stated in the description. ' +
                    'E.g. if a pill which lasts 3 steps is taken in the morning its effect will last until noon. ' +
                    'If granny throws up all pills will loose effect immediately.',
            },
            pillbox: {
                text: 'Drag the pills into the compartments for the time of day. Make sure to coordinate by-effects and react to ailments granny may have over the day.',
            },
            prescriptions: {
                text: 'You can read the prescription for each pill by clicking on it. It gives ' +
                    'you some information about each pill, but be aware that this' +
                    'information might be incomplete. Learn more about additional effects of a pill by checking ' +
                    'grannies reaction to it based on her diary entries.' +
                    'Try to memorize the prescriptions and diary entries you read as your drool will make ' +
                    'them less readable everytime you touch it.',
            },
            start: {
                text: 'When you are done, press the "Start" button and see how granny takes her pills throughout the day.',
            },
            diary: {
                text: 'After each day you can read grannies diary to find out how she was feeling during the day.' +
                    'Symptoms from Illnesses start at a certain time of the day. If Granny suffers from an illnesses on ' +
                    'one day, she will suffer from it for the rest of the week (always at the same time). The diary entries will ' +
                    'also give you information on how the pills you put into the box interacts with her illnesses, her status, the time of day and each other.' +
                    'Tip: You can start the first day without giving granny any medicine to understand which ' +
                    'illnesses granny is suffering from.',
            },
        },
        status: {
            hp: {
                name: 'Health',
                0: 'I was died',
                1: '',
                2: '',
                3: '',
                4: '',
                5: '',
                6: '',
                7: '',
                8: '',
                9: '',
                10: '',
            },
            happiness: {
                name: 'Happiness',
                0: 'I felt so incredebly down',
                1: 'I felt really sad',
                2: 'I was sad',
                3: 'I was not happy',
                4: '',
                5: '',
                6: '',
                7: '',
                8: '',
                9: 'I was excited',
                10: 'I felt exhilaratingly happy',
            },
            sickness: {
                name: 'Sickness',
                0: '',
                1: 'I felt a little sick',
                2: 'I felt really sick',
                3: 'I had to throw up',
            },
            sleepiness: {
                name: 'Sleepiness',
                0: '',
                1: 'I was somewhat sleepy',
                2: 'I felt so sleepy',
                3: 'I was so tired I could not keep my eyes open',
            },
            bloodPressure: {
                name: 'Blood Pressure',
                0: 'I am close to fading',
                1: 'I feel extremely dizzy',
                2: 'I feel very dizzy',
                3: 'I feel dizzy',
                4: 'I feel a little dizzy',
                5: '',
                6: 'I feel a little restless',
                7: 'I feel restless',
                8: 'I feel very restless',
                9: 'I feel extremely restless',
                10: 'I am close to exploding',
            },
        },
        winDialog: {
            title: 'You won!',
            text: 'You managed to keep grandma alive for {{value}} days!',
            score: 'Your score is {{value}}',
            alt: 'A happy dog giving a thumbs up. Grandma is in the background nitting',
        },
        loseDialog: {
            title: 'You lost!',
            text: 'Grandma died after {{value}} days.',
            alt: 'A sad dog looking at a departing ambulance.',
        },
    },
    mainMenu: {
        play: 'Play',
        settings: 'Settings',
        credits: 'Credits',
    },
    settings: {
        title: 'Settings',
        showPaw: 'Show arm',
    },
    levelSelection: {
        title: 'Select a level',
    },
    timer: {
        weekdays: {
            monday: 'Monday',
            tuesday: 'Tuesday',
            wednesday: 'Wednesday',
            thursday: 'Thursday',
            friday: 'Friday',
            saturday: 'Saturday',
            sunday: 'Sunday',
        },
        time: {
            0: 'morning',
            1: 'forenoon',
            2: 'noon',
            3: 'afternoon',
            4: 'evening',
            5: 'night',
            6: 'midnight',
        },
    },
    level: {
        level1: {
            name: 'Week 1',
            description: 'You are a dog. You have a schedule. You have to follow it.',
        },
        level2: {
            name: 'Week 2',
            description: 'You are a dog. You have a schedule. You have to follow it.',
        },
    },
    prescription: {
        title: 'Prescription for {{value}}',
        duration: 'This pill will last for {{value}} steps.',
        degradationNotice: 'Parts of the note are illegible: ',
    },
    diary: {
        nextPage: 'turn over',
        previousPage: 'turn back',
        entry: '{{time}}: {{parts}}.',
        combinator: ' and ',
        sentenceSeparator: '. ',
        tookPill: 'I took a {{pill}}',
        gotSick: 'I got {{ailment}}',
    },
    effect: {
        pill: {
            hapxi: {
                name: 'Hapxi',
                description: 'This 3§pill helps§3 Grandma with melancholy and makes her really happy.',
                prescription: '1§Really bad1§ if taken 2§too often2§',
                diary: 'I took a Hapxi',
            },
            /*slupninox: {
                name: 'Slupninox',
                description: 'This pill makes grandma 3§sleepy§3.',
                prescription: 'Be 1§careful§1! If taken 2§when grandma§2 is to sleepy she will fall 4§asleep§4.',
                diary: 'I took a Slupninox',
            },*/
            tumbumrum: {
                name: 'Tumbumrum',
                description: 'Helps if grandma feels sick.',
                prescription: 'Should be taken during 1§a meal1§',
                diary: 'I took a Tumbumrum',
            },
            antiau: {
                name: 'Antiau',
                description: 'Should be taken if grandma has a headache.',
                prescription: 'This pill might make grandma feel a bit sick.',
                diary: 'I took an Antiau',
            },
            chillma: {
                name: 'Chillma',
                description: 'Should be taken if grandma has high 1§blood pressure.1§',
                prescription: 'This pill might give grandma 2§a headache.2§',
                diary: 'I took an Chillma',
            },
        },
        ailment: {
            melancholy: {
                name: 'Melancholy',
                description: 'Grandma is getting melancholy.',
                diary: '',
            },
            /*insomnia: {
                name: 'Insomnia',
                description: 'Grandma cannot sleep well.',
                diary: 'Insomnia active',
            },*/
            stomachache: {
                name: 'Stomachache',
                description: 'Grandmas tummy really hurts',
                diary: 'my tummy hurts',
            },
            headache: {
                name: 'Headache',
                description: 'Oh no! Grandmas head feels like it explodes!',
                diary: 'my head hurts',
            },
            sickness: {
                name: 'Sickness',
                description: 'Grandmas is sick and will throw up eventually!',
                diary: '',
            },
            hypertension: {
                name: 'Hypertension',
                description: 'Grandmas blood pressure is increasing!',
                diary: '',
            },
        },
        neutral: {
            sleep: {
                name: 'Sleep',
                description: 'Grandma is tight asleep.',
                diary: 'zzzz...',
            },
            living: {
                name: 'Living',
                description: 'Grandma is living her life.',
                diary: '',
            },
        },
    },
};
